import axiosInstance from 'services/axiosMiddleware';

// Updated function to accept category data
export async function updateAsanaName(asanadata) {
  // console.log(posedata)

  try {
    const response = await axiosInstance.post('asana/updateAsanaName', asanadata);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
